import * as z from "zod/v4";

export const getPurpleDotIntegration = {
  name: "getPurpleDotIntegration" as const,
  input: z.object({}),
  output: z.object({
    purpleDotIntegration: z.optional(
      z.object({ enabled: z.boolean(), publicKey: z.string() }),
    ),
  }),
};

export type GetPurpleDotIntegrationOutput = z.infer<
  typeof getPurpleDotIntegration.output
>;

export const setPurpleDotIntegration = {
  name: "setPurpleDotIntegration" as const,
  input: z.object({
    enabled: z.boolean(),
    publicKey: z.string().min(1, "Public Key is required"),
    privateKey: z.string().min(1, "Private Key is required"),
  }),
  output: z.object({}),
};

export const updatePurpleDotIntegration = {
  name: "updatePurpleDotIntegration" as const,
  input: z.object({
    enabled: z.boolean().optional(),
    publicKey: z.string().min(1, "Public Key is required").optional(),
    privateKey: z.string().min(1, "Private Key is required").optional(),
  }),
  output: z.object({}),
};

export const disconnectPurpleDotIntegration = {
  name: "disconnectPurpleDotIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
